import { Component, OnInit, Input } from '@angular/core';
import { Container } from '../container-view/models/container';
import { ContainerItem } from '../container-view/models/container-item';

@Component({
  selector: 'app-premixed-quadrant-view',
  templateUrl: './premixed-quadrant-view.component.html'
})
export class PremixedQuadrantViewComponent implements OnInit {

  @Input() selectedContainer: Container;
  @Input() hasToggle: boolean;
  @Input() isCarrier: boolean;

  selectedCarrier: Container = null;
  selectedA1Carrier: Container = null;
  selectedA2Carrier: Container = null;
  selectedB1Carrier: Container = null;
  selectedB2Carrier: Container = null;
  selectedReactionPlate: Container;
  showChemical: boolean;
  showPrimer: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.selectedContainer.wellType === "384-Well"){
      this.showChemical = false;
      this.showPrimer = false;
      this.getCarriersFromReactionPlate();
      this.selectedCarrier = this.selectedA1Carrier;
    }else{
      this.selectedCarrier = this.selectedContainer;
    }    
  }

  getCarriersFromReactionPlate() {
    this.selectedA1Carrier = new Container();
    this.selectedA1Carrier.containerItems = new Array<ContainerItem>();
    this.selectedA2Carrier = new Container();
    this.selectedA2Carrier.containerItems = new Array<ContainerItem>();
    this.selectedB1Carrier = new Container();
    this.selectedB1Carrier.containerItems = new Array<ContainerItem>();
    this.selectedB2Carrier = new Container();
    this.selectedB2Carrier.containerItems = new Array<ContainerItem>();
    this.selectedReactionPlate = this.selectedContainer;    

    this.selectedReactionPlate.containerItems.forEach(containerItem => {
      let ci = containerItem;
      if (this.isCarrierA1(ci.positionCol, ci.positionRow)) {
        ci.positionCol = ci.positionCol / 2 + 0.5;
        ci.positionRow = ci.positionRow / 2 + 0.5;
        this.selectedA1Carrier.containerItems.push(ci);
      } else
        if (this.isCarrierA2(ci.positionCol, ci.positionRow)) {
          ci.positionCol = ci.positionCol / 2;
          ci.positionRow = ci.positionRow / 2 + 0.5;
          this.selectedA2Carrier.containerItems.push(ci);
        } else
          if (this.isCarrierB1(ci.positionCol, ci.positionRow)) {
            ci.positionCol = ci.positionCol / 2 + 0.5;
            ci.positionRow = ci.positionRow / 2;
            this.selectedB1Carrier.containerItems.push(ci);
          } else
            if (this.isCarrierB2(ci.positionCol, ci.positionRow)) {
              ci.positionCol = ci.positionCol / 2;
              ci.positionRow = ci.positionRow / 2;
              this.selectedB2Carrier.containerItems.push(ci);
            }
    });
  }

  getA1CarrierFromReactionPlate() {    
    if(this.selectedA1Carrier){
      this.selectedCarrier = this.selectedA1Carrier;
    }
  }

  getA2CarrierFromReactionPlate() {
    if(this.selectedA2Carrier){
      this.selectedCarrier = this.selectedA2Carrier;
    }     
  }

  getB1CarrierFromReactionPlate() {
    if(this.selectedB1Carrier){
      this.selectedCarrier = this.selectedB1Carrier;
    } 
  }

  getB2CarrierFromReactionPlate() {
    if(this.selectedB2Carrier){
      this.selectedCarrier = this.selectedB2Carrier;
    } 
  }

  isCarrierA1(col: number, row: number) {
    return col % 2 != 0 && row % 2 != 0;
  }
  isCarrierA2(col: number, row: number) {
    return col % 2 == 0 && row % 2 != 0;
  }
  isCarrierB1(col: number, row: number) {
    return col % 2 != 0 && row % 2 == 0;
  }
  isCarrierB2(col: number, row: number) {
    return col % 2 == 0 && row % 2 == 0;
  }
}
